import { render, staticRenderFns } from "./cash-box-threshold-manag.vue?vue&type=template&id=70e71069&"
import script from "./cash-box-threshold-manag.vue?vue&type=script&lang=js&"
export * from "./cash-box-threshold-manag.vue?vue&type=script&lang=js&"
import style0 from "./cash-box-threshold-manag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports